import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {HttpInterceptorCustom} from './utils/http.interceptor';


export const APP_PROVIDERS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptorCustom,
    multi: true
  },
];
